import { createDate, isAfter } from '@lingoda/dates';

export const isAlreadyStartedClass = (startDate: string, now: Date = createDate()) =>
    isAfter(now, createDate(startDate));
